import {isAvailableDonationTicket} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {getPlaceInfoItems} from '../../../../../../selectors/seating/place'
import {LabelWithValue} from '../../../../../common/label-with-value'
import {TicketFees} from '../../ticket-fees'
import {TicketPrice} from '../../ticket-price'
import {classes} from './ticket-info-texts.st.css'
import {TicketInfoTextsProps} from './index'

export const TicketInfoTexts = ({
  place,
  inPopover,
  inDescription,
  inDrawer,
  inPricingOptionsModal,
}: TicketInfoTextsProps) => {
  const {t} = useTranslation()
  const placeInfo = getPlaceInfoItems(place, t)
  const ticketName = place.ticket?.name

  const hidePrice =
    (place.ticket && isAvailableDonationTicket(place.ticket) && !inPopover && !inDescription) || inPricingOptionsModal

  return (
    <div className={classes.container}>
      <div className={classNames(classes.infoContainer, {[classes.paddingRight]: !inPopover})}>
        {placeInfo.map(({label, value}, index) => (
          <LabelWithValue key={index} labelClassName={classes.label} label={label} value={value} />
        ))}
      </div>
      <div className={classes.ticketInfo}>
        <Text className={classes.ticketName}>{ticketName}</Text>
        {hidePrice ? null : (
          <>
            <TicketPrice place={place} inDescription={inDescription} inPopover={inPopover} inDrawer={inDrawer} />
            <TicketFees place={place} inPopover={inPopover} />
          </>
        )}
      </div>
    </div>
  )
}
